module.exports = __webpack_public_path__ + "static/media/Closed.5a11b84d.svg";